export const BASE_URL = import.meta.env.PROD ? '' : 'http://localhost:8000'

export const MEDIA_URL = import.meta.env.PROD
  ? ''
  : 'http://localhost:8000/media/'

export const API_URL = import.meta.env.VITE_API_URL
